import { Injectable } from "@angular/core";
import { interval, Observable, of } from "rxjs";
import { catchError, exhaustMap, last, map, take, takeWhile } from "rxjs/operators";
import { Response } from "../shared/models/Response";
import { EmisorService } from "./emisor.service";
import { PaymentResolution } from "../models/Payment/PaymentResolution";

@Injectable({
	providedIn: "root",
})
export class WebpayPaymentService {
	constructor(private emisorService: EmisorService) {}
	redirectToWebpay(url: string, token: string): void {
		const form = document.createElement("form");
		form.method = "post";
		form.target = "_blank";
		form.action = url;
		document.body.appendChild(form);

		const input = document.createElement("input");
		input.type = "hidden";
		input.name = "token_ws";
		input.value = token;
		form.appendChild(input);
		form.submit();
	}
	pollPaymentStatus(token: string, maxAttempts: number = 25, pollingInterval: number = 4000): Observable<PaymentResolution> {
		return interval(pollingInterval).pipe(
			take(maxAttempts),
			exhaustMap(() => this.emisorService.verifyTransbankStatus(token).pipe(
				map((response: Response<PaymentResolution>) => response.data),
				// Una consulta puede fallar mientras el postpago aún conserva locks o
				// concilia sus efectos. Ese fallo consume un intento, pero no debe
				// cancelar los intentos posteriores del polling.
				catchError(() => of(null as PaymentResolution | null)),
			)),
			takeWhile((payment: PaymentResolution | null) => !payment || !payment.isTerminal, true),
			last(),
			map(payment => payment && payment.isTerminal ? payment : this.abandonedResult()),
			catchError(() => of(this.abandonedResult()))
		);
	}
	payWithWebpay(url: string, token: string): Observable<boolean> {
		this.redirectToWebpay(url, token);
		return this.pollPaymentStatus(token).pipe(map(payment => payment.result === "Approved" && payment.paid));
	}

	payWithWebpayResult(url: string, token: string): Observable<PaymentResolution> {
		this.redirectToWebpay(url, token);
		return this.pollPaymentStatus(token);
	}

	private abandonedResult(): PaymentResolution {
		return {
			result: "Abandoned",
			isTerminal: false,
			paid: false,
			message: "No se recibió un resultado definitivo. La orden seguirá conciliándose hasta expirar."
		};
	}
}
